<template>
  <div class="playtest-info">
    <div class="playtest-info-name-date-container">
      <div class="playtest-info-name">
        <span class="playtest-info-name-title">Playtest Name:</span>
        <span class="playtest-info-name-content">{{ gameName }}</span>
      </div>
      <div class="playtest-info-date">
        <span class="playtest-info-date-title">Playtest Period:</span>
        <span class="playtest-info-date-content">{{ playtestDate }}</span>
      </div>
    </div>
    <div class="playtest-info-player-info">
      <span class="playtest-info-player-info-title">Player Information:</span>
      <span class="playtest-info-player-info-content-container">
        <span class="questions" v-for="(question, index) in playerQuestions" :key="index">
          {{ question }}
          Yes
          <input type="checkbox" class="circular-checkbox" @change="onAnswer($event, 0, index, 1)" :checked="playerAnswers[index] === 'Yes'" />
        </span>
      </span>
    </div>
    <div class="playtest-info-other-info">
      <span class="playtest-info-other-info-title">Other Information:</span>
    </div>
   </div>
</template>

<script>

  export default {
    name: "PlaytestInfo",
    data() {
      return {
        userType: window.localStorage.getItem("userType") ? parseInt(window.localStorage.getItem("userType")) : -1, // 0: Tester, 1: dev, 2: Admin
        // get from db after
        gameName: window.localStorage.getItem("gameName"),
        playtestDate: JSON.parse(window.localStorage.getItem("playPeriodInfo"))['startTime'] + " - " + JSON.parse(window.localStorage.getItem("playPeriodInfo"))['endTime'],
        playerQuestions: JSON.parse(window.localStorage.getItem("playPeriodInfo"))['questions'],
        playerAnswers: JSON.parse(window.localStorage.getItem("savedPlayerInfo")) ? JSON.parse(window.localStorage.getItem("savedPlayerInfo")) : null,
      }
    },
    mounted() {
      this.setupQuestions();
      // redirect to login if the user is not logged in
      if (window.localStorage.getItem("userType")) {
        this.userType = parseInt(window.localStorage.getItem("userType"));
        console.log(this.userType);
      } else {
        this.$router.push({
          name: 'login',
        })
      }
    },
    methods: {
      setupQuestions() {
        //this is undefined
        console.log(this.playerAnswers);
        if (!this.playerAnswers) {
          this.playerAnswers = [];
          this.playerQuestions.forEach(question => {
            this.playerAnswers.push('No');
          })
        }
      },
      onAnswer(event, questionType, index, value) {
        // Y/N Question
        if (questionType === 0) {
          if (event.target.checked) {
            this.playerAnswers[index] = 'Yes';
          }
          else {
            this.playerAnswers[index] = 'No';
          }
        }
        this.$emit("update_player_info", this.playerAnswers);
      }
    },
  }
</script>

<style scoped>
  .playtest-info {
      display: flex;
      width: 100%;
      flex-direction: column;
      margin-bottom: 2%;
  }
  /* Name and date */
  .playtest-info-name-date-container {
      display:flex;
      height: 15%;
      width: 100%;
  }
  .playtest-info-name {
      display: flex;
      align-content: flex-start;
      justify-content: flex-start;
      background-color: white;
      height: 100%;
      width: 45%;
      margin-right: 10%;
      border-radius: 10px;
      flex-direction: column;
  }
  .playtest-info-name-title {
      color: #FF7222;
      font: 24px Poppins, bold;
      padding-left: 2%;
      padding-top: 0.5%;
  }
  .playtest-info-name-content {
      width: fit-content;
      height: auto;
      background-color: #BEBEBE;
      margin-left: 2%;
      margin-right: 2%;
      margin-top: 0.5%;
      padding-left: 1%;
      padding-right: 1%;
      border-radius: 10px;
  }
  .playtest-info-date {
    display: flex;
    background-color: white;
    height: 100%;
    width: 45%;
    border-radius: 10px;
    flex-direction: column;
  }
  .playtest-info-date-title {
    color: #FF7222;
    font: 24px Poppins, bold;
    padding-left: 2%;
    padding-top: 0.5%;
  }
  .playtest-info-date-content {
    width: fit-content;
    height: auto;
    background-color: #BEBEBE;
    margin-left: 2%;
    margin-right: 2%;
    margin-top: 0.5%;
    padding-left: 1%;
    padding-right: 1%;
    border-radius: 10px;
  }
  /* Player information */
  .playtest-info-player-info {
    display: flex;
    align-content: flex-start;
    justify-content: flex-start;
    margin-top: 2.5%;
    background-color: white;
    height: 35%;
    width: 100%;
    border-radius: 10px;
    flex-direction: column;
  }
  .playtest-info-player-info-title {
    color: #FF7222;
    font: 24px Poppins, bold;
    padding-left: 1%;
    padding-top: 0.5%;
  }

  .playtest-info-player-info-content-container {
      display: flex;
    width: fit-content;
    height: auto;
    margin-right: 2%;
    margin-top: 0.5%;
    padding-left: 1%;
    padding-right: 1%;
    border-radius: 10px;
    flex-direction: column;
  }
  /* Other information on playtest */
  .playtest-info-other-info {
    display: flex;
    align-content: flex-start;
    justify-content: flex-start;
    margin-top: 2.5%;
    background-color: white;
    height: 35%;
    width: 100%;
    border-radius: 10px;
    flex-direction: column;
  }
  .playtest-info-other-info-title {
    color: #FF7222;
    font: 24px Poppins, bold;
    padding-left: 1%;
    padding-top: 0.5%;
  }
</style>



// WEBPACK FOOTER //
// src/components/playtest/Playtest-Info.vue